import { isDatesEqualInUTC, isSameDate } from '@epicuro-next/utilities';
import {
  BasketItem,
  BasketUpdateItem,
  OrderType,
} from 'graphql-api/baskets-api-interfaces';

import { ExtendedBasketItem } from '../../state/reducers/basket-data.reducer';

export function getExistedBasketItemIndex(
  basketItem: BasketUpdateItem | ExtendedBasketItem | BasketItem,
  accountId: string,
  addressId: string,
  basketItems: BasketItem[] | ExtendedBasketItem[],
) {
  if (basketItem.orderType === OrderType.Now) {
    return basketItems.findIndex((item) => {
      return (
        item.accountId === accountId &&
        item.addressId === addressId &&
        item.orderType === basketItem.orderType &&
        item.productId === basketItem.productId &&
        basketItem.requestedDeliveryDate &&
        isDatesEqualInUTC(
          item.requestedDeliveryDate,
          basketItem.requestedDeliveryDate,
        )
      );
    });
  }
  return basketItems.findIndex((item) => {
    return (
      item.accountId === accountId &&
      item.addressId === addressId &&
      item.productId === basketItem.productId &&
      (futureOrderEqualDates(item, basketItem) ||
        bulkOrderEqualDates(item, basketItem))
    );
  });
}

export function getExistedBasketItem(
  updateBasketItem: BasketUpdateItem | ExtendedBasketItem | BasketItem,
  accountId: string,
  addressId: string,
  basketItems: BasketItem[],
) {
  const existingItemIndex = getExistedBasketItemIndex(
    updateBasketItem,
    accountId,
    addressId,
    basketItems,
  );
  return basketItems?.[existingItemIndex];
}

export function bulkOrderEqualDates(
  item: BasketItem,
  basketItem: BasketUpdateItem | ExtendedBasketItem | BasketItem,
) {
  if (!item.consignmentEndDate || !basketItem.consignmentEndDate) return false;

  return (
    isSameDate(
      item.consignmentStartDate ?? '',
      basketItem.consignmentStartDate ?? '',
    ) &&
    isSameDate(
      item.consignmentEndDate ?? '',
      basketItem.consignmentEndDate ?? '',
    )
  );
}

export function futureOrderEqualDates(
  item: BasketItem,
  updateBasketItem: BasketUpdateItem | ExtendedBasketItem | BasketItem,
) {
  if (item.consignmentEndDate || updateBasketItem.consignmentEndDate)
    return false;

  return isSameDate(
    item.requestedDeliveryDate,
    updateBasketItem.requestedDeliveryDate,
  );
}
